import SelectAssetsPage from "domains/liquidity/pages/SelectAssetsPage/SelectAssetsPage";

export default SelectAssetsPage;
